import * as React from 'react';
export const DMSvg = React.forwardRef(function DMSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#159570',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M6 0h1v12H6z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M0 4h16v1H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M0 7h16v1H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M0 5h16v2H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M7 0h2v12H7z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M9 0h1v12H9z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        fillRule: 'nonzero',
        d: 'M8 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        d: 'M6 0h1v1H6V0Zm0 11h1v1H6v-1ZM0 4h1v1H0V4Zm15 0h1v1h-1V4Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        d: 'M9 0h1v1H9V0Zm0 11h1v1H9v-1ZM0 7h1v1H0V7Zm15 0h1v1h-1V7Z',
      }),
    ),
  );
});
DMSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var DM = {
  category: 'flag',
  colorable: false,
  name: 'DM',
  svg: DMSvg,
};
